import Request from '@/api'

const user = {
  state: {
    userStatus: undefined,
    userInfo: null
  },
  mutations: {
    SET_STATUS(state, code) {
      state.userStatus = code
    },
    SET_USERINFO(state, info) {
      state.userInfo = info
    }
  },
  actions: {
    // 获取权限
    async getAuth({ commit }, code) {
      const params = { apiReject: true, code }
      if (process.env.NODE_ENV === 'development') params.openId = 'o4tHsw8OjnZalLIJdTxg88E9Yi9M'
      const res = await Request.getAuth(params)
      commit('SET_STATUS', res.code)
      if (res.retCode === '000') {
        commit('SET_USERINFO', res.data)
        return true
      } else return res.msg || res.message
    }
  }
}

export default user
